module.exports = __webpack_public_path__ + "ico/32.png";